import { render, staticRenderFns } from "./UserVerificationBadges.vue?vue&type=template&id=3eb0e0f2&scoped=true&"
import script from "./UserVerificationBadges.vue?vue&type=script&lang=js&"
export * from "./UserVerificationBadges.vue?vue&type=script&lang=js&"
import style0 from "./UserVerificationBadges.vue?vue&type=style&index=0&id=3eb0e0f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb0e0f2",
  null
  
)

export default component.exports